import type { PropsWithChildren } from 'react';
import styled, { type CSSProperties } from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import type { RGBColor } from '@sorare/core/src/style/types';

const Root = styled.div`
  border-radius: var(--triple-unit);
  background-color: var(--c-black);
`;
const Background = styled(Horizontal)`
  border-radius: var(--triple-unit);
  background-color: rgba(var(--rgb-color), 0.2);
  padding: var(--half-unit) var(--unit);
`;

type Props = { rgbColor: RGBColor };
export const RewardWrapperHeader = ({
  rgbColor,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Root>
      <Background style={{ '--rgbColor': rgbColor } as CSSProperties} gap={0.5}>
        {children}
      </Background>
    </Root>
  );
};
